module.exports = "/_next/static/images/avatar-frame-tier-3-crew-477808d238e9f74eca6639618e1dc635.png";